'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');
var _ = require('lodash');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * send Measurement Protocol hit to Google
     * @param {Object} describing the event, will be converted to payload string per docs: https://developers.google.com/analytics/devguides/collection/protocol/v1/devguide
     * @returns {promise}
     */
    sendHit: function sendHit(analyticsEventObject) {

        var queryParams = null;

        var payload = this.constructPayload(analyticsEventObject);

        return this.postApiRequest(this.getUrl().googleAnalytics, queryParams, payload);
    },

    // generalized payloadConstructor which builds up body according to format specified by Google Measurement Protocol
    // https://developers.google.com/analytics/devguides/collection/protocol/v1/devguide#enhancedecom

    // things that break Google MP:
    //      1) "undefined" string value for parameter
    //      2) a currency number with too many decimal places

    constructPayload: function constructPayload(protocolMeasurementParameters) {
        var payload = '';
        var isFirstParameter = true;

        var parameters = Object.keys(protocolMeasurementParameters);
        parameters.forEach(function (parameter) {
            if (protocolMeasurementParameters[parameter] && protocolMeasurementParameters[parameter] !== 'undefined') {
                if (isFirstParameter) {
                    isFirstParameter = false;
                } else {
                    payload += '&';
                }
                payload += parameter + '=' + encodeURIComponent(protocolMeasurementParameters[parameter]);
            }
        });
        return payload;
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/googleAnalyticsMeasurementProtocolServiceClient.js
// module id = 778
// module chunks = 0